const SESSION_KEY = 'mipae:session_id';

// Respaldo en memoria por si sessionStorage no está disponible (modo incógnito,
// iframes con storage particionado, algunos WebView): el arranque lee el
// session_id muy temprano y no debe crashear si el storage o crypto fallan.
let memoriaId = null;

function generarId() {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  } catch {
    /* crypto.randomUUID ausente o bloqueado: caemos al fallback de abajo */
  }
  return `sess-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getOrCreateSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = generarId();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    // sessionStorage bloqueado: usamos un id estable en memoria para esta sesión.
    if (!memoriaId) memoriaId = generarId();
    return memoriaId;
  }
}

export function clearSession() {
  try { sessionStorage.removeItem(SESSION_KEY); } catch { /* storage no disponible */ }
  memoriaId = null;
}
